import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from 'i18n-react';

const ContactViewCard = ({ name, title, email, description }) => (
  <div className="contactView__content">
    <h1>{name}</h1>

    <h2 className="title">{title}</h2>
    {name !== 'Valery Alce' && <p className="description">{description}</p>}
    {name === 'Valery Alce' && <p className="description">North America</p>}

    <a href={`mailto:${email}`}>
      <FontAwesomeIcon icon={['fas', 'envelope']} />
      {email}
    </a>
  </div>
);

export default ContactViewCard;
